import { defaults } from 'lodash-es';

import { CourseType, MyVoucherStudyingType } from '../../../../../../resources/@types/courseSchema';
import useNextUrlState from '../../../../../hooks/useNextUrlState';
import type { StringifyObject } from '../../../../../utils/typeUtil';
import { COURSE_TYPE, MY_COURSES_SORTING } from '../MyCoursesPageFilter';
import type { VoucherMyQueryParameter } from '../queries/useClientApiVoucherMyQuery';
import { CoursesSort } from '../sort';

const isTrue = (value: string) => value === 'true';

export default function useUrlStateForMyCourses() {
  const { value, ...pageParams } = useNextUrlState<StringifyObject<VoucherMyQueryParameter>>({
    isReplace: true,
  });

  const filterValue = defaults(value, {
    courseType: CourseType.ON,
    isReviewable: 'false',
    isExcludeExpired: 'true',
    isArchived: 'false',
    pageNumber: '1',
    sort: CoursesSort.RECENT_STUDYING,
  });

  function getCurrentFilterForGTM() {
    const { courseType } = filterValue;
    return {
      isReviewable: isTrue(filterValue.isReviewable) ? '수강평 작성 가능' : '',
      studying: !!filterValue.studying
        ? filterValue.studying === MyVoucherStudyingType.COMPLETED
          ? '완강'
          : '학습중'
        : '',
      courseType: isCourseType(courseType) ? COURSE_TYPE[courseType] : COURSE_TYPE.ON,
    };
  }

  function getSortLabelForGTM() {
    const { sort } = filterValue;

    return isMyCoursesSorting(sort) ? MY_COURSES_SORTING[sort] : MY_COURSES_SORTING.COURSE_TITLE;
  }

  return {
    ...pageParams,
    currentFilter: filterValue,
    getCurrentFilterForGTM,
    getSortLabelForGTM,
  };
}

function isCourseType(value: string): value is keyof typeof CourseType {
  return Object.keys(COURSE_TYPE).includes(value);
}

function isMyCoursesSorting(value: string): value is CoursesSort {
  return (
    value === CoursesSort.RECENT_APPLY ||
    value === CoursesSort.RECENT_STUDYING ||
    value === CoursesSort.EARLIEST_EXPIRATION
  );
}
